<script>
import { exportAsCsv } from '../../../utils/fileUtils'
import { getMvsVinDetails } from './offerUtils'
import Modal from '../../../Modal'
import VINMVSList from './VINMVSList'
import TabSet from '../../../slds/tabs/TabSet'
import Tab from '../../../slds/tabs/Tab'
export default {
  props: {
    mvsNames: Object,
    offer: Object
  },
  components: {
    Tab,
    TabSet,
    Modal,
    VINMVSList
  },
  async created () {
    this.mappedOffer = getMvsVinDetails(this.offer)
    this.selectedTab = this.mappedOffer.mmvsList && this.mappedOffer.mmvsList.length ? 0 : 1
  },
  data () {
    return {
      mappedOffer: {},
      selectedTab: -1,
      showPaginationSection: false,
      pageNumber: 0,
      pageSize: 100
    }
  },
  computed: {
    startIndex () {
      return this.pageNumber * this.pageSize
    },
    endIndex () {
      return ((this.pageNumber + 1) * this.pageSize - 1)
    }
  },
  methods: {
    downloadCsv (offer) {
      const today = new Date()
      if (this.selectedTab === 0) {
        const fileName = `${offer.title}_MVS_${this.$options.filters.formatDate(today, this.$t('general.dateFormat'))}.csv`
        const content = [
          [
            this.$t(`campaignDesigner.contentSelectionAndTag.mvs`),
            this.$t('campaignDesigner.contentSelectionAndTag.status'),
            this.$t('campaignDesigner.contentSelectionAndTag.itemTypeDescription'),
            this.$t('campaignDesigner.contentSelectionAndTag.itemDescription'),
            this.$t('campaignDesigner.contentSelectionAndTag.quantity'),
            this.$t('campaignDesigner.contentSelectionAndTag.offerType'),
            this.$t('campaignDesigner.contentSelectionAndTag.priceValue')
          ]
        ]

        offer.mmvsList.forEach(row => {
          content.push([
            `${row.mvs} - ${this.mvsNames[row.mvs]}`,
            row.status && row.status.length ? this.$t(`churnScore.${row.status}`) : '',
            row.itemTypeDescription,
            row.itemDescription ? row.itemDescription.split('\n').join('') : '',
            row.quantity,
            row.offerType,
            row.priceValue
          ])
        })

        exportAsCsv(content, fileName)
      } else {
        const fileName = `${offer.title}_VIN_${this.$options.filters.formatDate(today, this.$t('general.dateFormat'))}.csv`
        const content = [
          [
            this.$t(`campaignDesigner.contentSelectionAndTag.vin`),
            this.$t('campaignDesigner.contentSelectionAndTag.status'),
            this.$t('campaignDesigner.contentSelectionAndTag.itemTypeDescription'),
            this.$t('campaignDesigner.contentSelectionAndTag.itemDescription'),
            this.$t('campaignDesigner.contentSelectionAndTag.quantity'),
            this.$t('campaignDesigner.contentSelectionAndTag.offerType'),
            this.$t('campaignDesigner.contentSelectionAndTag.priceValue')
          ]
        ]

        offer.vinList.forEach(row => {
          content.push([
            row.vin,
            row.status && row.status.length ? this.$t(`churnScore.${row.status}`) : '',
            row.itemTypeDescription,
            row.itemDescription ? row.itemDescription.split('\n').join('') : '',
            row.quantity,
            row.offerType,
            row.priceValue
          ])
        })

        exportAsCsv(content, fileName)
      }
    },
    isNextButtonDisabled () {
      if (this.selectedTab === 0) {
        return this.mappedOffer.mmvsList.length <= (this.pageNumber + 1) * this.pageSize
      } else if (this.selectedTab === 1) {
        return this.mappedOffer.vinList.length <= (this.pageNumber + 1) * this.pageSize
      } else {
        return true
      }
    }
  },
  watch: {
    selectedTab (tab) {
      this.pageNumber = 0
      if (this.selectedTab === 0) {
        this.showPaginationSection = this.mappedOffer.mmvsList.length > this.pageSize
      } else if (this.selectedTab === 1) {
        this.showPaginationSection = this.mappedOffer.vinList.length > this.pageSize
      } else {
        this.showPaginationSection = false
      }
    }
  }
}
</script>
<template>
  <transition name="fade">
    <Modal
      :title="$t('campaignDesigner.contentSelectionAndTag.vinMvsList')"
      size="medium"
      @close="$emit('closeModal')">

      <template slot="footer">
        <div class="pagination-section">
          <div v-if="showPaginationSection">
            <button class="slds-button slds-button_neutral slds-m-right--small" @click="pageNumber = pageNumber - 1" :disabled="pageNumber === 0"> &lt; </button>
            <span> {{ pageNumber + 1 }} </span>
            <button class="slds-button slds-button_neutral slds-m-left--small" @click="pageNumber = pageNumber + 1" :disabled="isNextButtonDisabled()"> &gt; </button>
          </div>
        </div>
        <button slot="actions" class="slds-button slds-button_brand" @click="downloadCsv (mappedOffer)">{{$t('campaignDesigner.contentSelectionAndTag.downloadCsv')}}</button>
      </template>

      <TabSet @updateTabIndex="selectedTab = $event.index" tab-set-id="vin_mvs_modal">
        <Tab :label="$t('campaignDesigner.contentSelectionAndTag.mvsTabLabel', {count: mappedOffer.mmvsList.length})" tab-set-id="vin_mvs_modal">
          <VINMVSList type="mvs" :items="mappedOffer.mmvsList.slice(startIndex, endIndex + 1)" :mvs-names="mvsNames" />
        </Tab>
        <Tab :label="$t(`campaignDesigner.contentSelectionAndTag.${mappedOffer.includeOrExcludeVins}Vin`, {count: mappedOffer.vinList.length})" v-if="mappedOffer.vinList.length" tab-set-id="vin_mvs_modal">
          <VINMVSList type="vin" :items="mappedOffer.vinList.slice(startIndex, endIndex + 1)" />
        </Tab>
      </TabSet>
    </Modal>
  </transition>
</template>
<style lang="scss" scoped>
  .pagination-section {
    display: flex;

    & > div {
      margin: auto;
    }
  }
</style>
